/**
 * Feature flags for V2 rollout (per-section).
 * How flags combine with the user toggle: see src/routes/V2RouteWrappers.jsx (file header).
 * When true, V2 is available for that screen (and `preferV2` in experienceToggleContext selects V2 vs V1).
 * All section flags are ON; default user preference is V2 (`src/context/experienceToggleContext.jsx`).
 * Routes with no V2 implementation (login, profile, QR, some banners, etc.) stay V1 regardless.
 */
const FLAGS = {
  // ——— V2 completed ———
  USE_V2_WELCOME: true,           // Home
  USE_V2_OVERVIEW: true,          // Dashboard
  USE_V2_CPV_LISTING: true,       // CPV Listing
  USE_V2_CHANGE_PASSWORD: true,  // Change Password
  USE_V2_LOGIN_HISTORY: true,    // Login History
  USE_V2_MANAGE_PERMISSION: true,// Manage Permission
  USE_V2_HELP_SUPPORT: true,     // Help & Support
  USE_V2_MANAGE_MCC: true,       // Manage MCC
  USE_V2_MANAGE_AUTOPAY: true,   // Manage Autopay
  USE_V2_MANAGE_ADMIN: true,   // Manage Admin
  USE_V2_CARD_MANAGEMENT: true, // Card product + org card management (V2 shipped; toggle + flag)
  USE_V2_ACCESS_MANAGEMENT: true, // Permission management, role management, role ↔ permissions
  USE_V2_MANAGE_PAYBACK: true, // Payback listing, add payback, request list, approval users
  USE_V2_ORGANIZATION_HUB: true, // Organization list + society dashboard tabs (V2)
  USE_V2_MANAGE_OPERATOR: true, // Operator list + edit (V2RouteWrapper + user toggle)
  USE_V2_MANAGE_NOTIFICATION: true, // Notification hub, list, send, banner list (V2RouteWrapper + user toggle)
  USE_V2_TICKET_MANAGEMENT: true, // Tickets list, create, edit (V2RouteWrapper + user toggle)
  USE_V2_TRANSACTIONS: true, // Payments + settlements listing (V2RouteWrapper + user toggle)
  USE_V2_TRANSACTION_CHARGES: true, // Transaction charges listing (V2RouteWrapper + user toggle)
  USE_V2_PARTNER: true, // Society partner list, program manager, details (V2RouteWrapper + flag)
  USE_V2_PAYMENT_SETTINGS: true, // Payment settings (role & modes, limits, fees, card config, mcc/default tabs)
  USE_V2_MANAGE_CARD: true, // Legacy manage-card section (assign, orders, physical/virtual card + inventory)
  USE_V2_MANAGE_SOUNDBOX: true, // Manage soundbox orders
  USE_V2_MANAGE_DISTRIBUTOR: true, // Distributor list, add/edit tabs, society partner table modals — V2RouteWrapper + user toggle
  USE_V2_MANAGE_REPORTS: true, // All /reports* + email + UPI + settlement/transaction — V2RouteWrapper; page bodies lazy-load legacy modules until fully ported to DS
  USE_V2_RECONCILE_COLLECT: true, // /reconcile/* + add payment — V2RouteWrapper + lazy legacy modules
  USE_V2_USER: true, // Merchant lists + detail: UserListV2 / UserDetailV2 when toggle + flag
  USE_V2_LOGIN: true, // / and /login — LoginV2 split-screen UI
  USE_V2_PROFILE: true, // /profile
  USE_V2_BENE_USER_LIST: true, // /user-list/:accountNumber/:ifscCode
  USE_V2_QR_GENERATE: true, // /qr-generate
  USE_V2_MANAGE_BANNER_LEGACY: true, // /manage-banner, /banner/add, /banner/edit/:id (legacy list/form)
  USE_V2_INVENTORY_MANAGEMENT: true,
  USE_V2_TID_WHITELISTING: true, // /tid-whitelisting (Distributor TID whitelisting screen)
  USE_V2_CASHBACK_CONFIG: true,
  USE_V2_FORM_60:true,
  USE_V2_SCHEDULE_MAINTENANCE:true,
};

export function getFlag(key) {
  return FLAGS[key] ?? false;
}

export default FLAGS;
